// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_67952280","outerContainer":"_2df0f760","secondaryToolbar":"c895823a","doorHangerRight":"a7a17383","toolbarContainer":"d47044f6","toolbarViewerMiddle":"bb49b5fc","progressBar":"_55da2f37","back-to-application":"_820a1f65","root":"_8af859a4","markerValue":"_2a98b44a","markerLine":"d8ab2a93"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/Marker/index.styl
// module id = 5049
// module chunks = 39